var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckcircleLime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0013 0.666672C13.6013 0.666672 17.3346 4.40001 17.3346 9.00001C17.3346 13.6 13.6013 17.3333 9.0013 17.3333C4.4013 17.3333 0.667969 13.6 0.667969 9.00001C0.667969 4.40001 4.4013 0.666672 9.0013 0.666672ZM9.0013 15.6667C12.6846 15.6667 15.668 12.6833 15.668 9.00001C15.668 5.31667 12.6846 2.33334 9.0013 2.33334C5.31797 2.33334 2.33464 5.31667 2.33464 9.00001C2.33464 12.6833 5.31797 15.6667 9.0013 15.6667ZM9.83464 9.00001V12.3333H8.16797V9.00001H5.66797L9.0013 5.66667L12.3346 9.00001H9.83464Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckcircleLime);
export default __webpack_public_path__ + "static/media/checkcircle-lime.c3a923a57cb59fd095e95d97355d7d86.svg";
export { ForwardRef as ReactComponent };